import axiosPublicClient from "../../../../axiosPublicClient"
import axiosClient from "../../../../axiosClient"

export default async (key, referenceNumber) => {

    if (key) {
        const result = await axiosPublicClient.get(`/background-check-form?key=${key}`)

        return result.data
    }

    const result = await axiosClient.get(`/background-check-form?referenceNumber=${referenceNumber}`)

    return result.data

}
